<template>
  <div>

    <p class="dash-heading"><i class="fa fa-globe" />&nbsp;Finance Summary</p>
    <el-row :gutter="gutter">

      <el-col :span="24">

        <xolas-table
          hide-org-badge
            title="Finance Statement"
            :url="'report/finance/summary' + (siteId ? '/' + siteId : '')"
            table-ref="fin-stmt-table"
            :fields="fields"
            track-by="siteName"
            search-placeholder="Site Name, Site ID, Telco Name, Telco Site ID">

            <template #name="props">
              <org-badge :name="props.rowData.name" :short-name="props.rowData.shortName" :color="props.rowData.colourCode" :no-full-name="isDesktop" />
            </template>

            <template #totals="props">
              <el-popover
                  v-if="props.rowData.total > 0"
                  placement="left"
                  width="200"
                  trigger="hover">
                  <table v-if="props.rowData.total > 0" class="el-table">
                    <tr v-if="props.rowData.currentRate > 0"><td>Current Rate</td><td><b>{{formatFloat(props.rowData.currentRate)}}</b></td></tr>
                    <tr v-if="props.rowData.siteItems > 0"><td>Site Items</td><td><b>{{formatFloat(props.rowData.siteItems)}}</b></td></tr>
                    <tr v-if="props.rowData.sharerItems > 0"><td>Sharer Items</td><td><b>{{formatFloat(props.rowData.sharerItems)}}</b></td></tr>
                    <tr v-if="props.rowData.voSharerItems > 0"><td>V.O. Items</td><td><b>{{formatFloat(props.rowData.voSharerItems)}}</b></td></tr>
                    <tr v-if="props.rowData.equipFees > 0"><td>Equip. Fees</td><td><b>{{formatFloat(props.rowData.equipFees)}}</b></td></tr>
                  </table>
                  <template #reference><el-button>{{formatMoney(props.rowData.total)}}</el-button></template>
                </el-popover>
                <el-button v-else :disabled="props.rowData.total === 0">{{formatMoney(props.rowData.total)}}</el-button>


            </template>

        </xolas-table>

      </el-col>

      <!-- @TODO fix stats --
       <el-col align="center" :span="8">
         <dash-text :value="formatIntegerber(st.total, 0)" caption="Total Billing" />
       </el-col>

       <el-col align="center" :span="8">
         <dash-text :value="formatIntegerber(Math.abs(st.outstanding), 0)" caption="Total Overdue" no-plural color="indianred" />
       </el-col>

       <el-col align="center" :span="8">
         <dash-text :value="formatIntegerber(st.totalPaid, 0)" caption="Total Paid" no-plural color="seagreen" />
       </el-col>


       <el-col align="center" :span="24">

         <column-chart
          :data="[{name: 'Total Invoiced', data: {'Current': st.total}},
          {name: 'Outstanding', data: {'Current': Math.abs(st.outstanding)}},
          {name: 'Paid', data: {'Current': st.totalPaid}}]"
           :colors="['#3366cc', '#dc3912', '#109618']" legend="bottom" />

       </el-col>

    </el-row>

    <el-row>
      <el-col :span="24">
        <data-table
            title="Finance Statement"
            url="report/finance/summary"
            table-ref="fin-stmt-table"
            :fields="fields"
            track-by="name"
            :hideTop="true"
            />

      </el-col>
-->
    </el-row>

  </div>
</template>

<script>

import SiteMixins from '@/mixins/SiteMixins'

export default {

  mixins: [SiteMixins],

  props: {
    stats: {
      type: Object,
      default: null
    },

    siteId: {
      type: Number,
      default: null
    }
  },

  data () {
    return {
      st: null,
      gutter: 16,

      // minWidth hints mirror the pre-migration vuetable-2 render, measured at
      // 1504px viewport (.context/xol-234-baselines/metrics.json,
      // finance-summary[0]) — el-table distributes un-sized columns equally,
      // which does not match the legacy content-based auto layout.
      fields: [
        {
          name: 'siteName',
          title: 'Site Name',
          titleClass: 'text-success',
          dataClass: 'text-success',
          minWidth: 180
        },
        {
          name: 'siteId',
          title: 'Site Id',
          titleClass: 'hidden-md-and-down text-success',
          dataClass: 'hidden-md-and-down text-success',
          minWidth: 116
        },
        {
          name: 'siteGroup',
          title: 'Site Group',
          titleClass: 'hidden-md-and-down text-warning',
          dataClass: 'hidden-md-and-down text-warning',
          minWidth: 70
        },
/*
        {
          name: 'sharerNo',
          title: 'No.',
          titleClass: 'hidden-md-and-down',
          dataClass: 'hidden-md-and-down'
        },
*/
        {
          name: '__slot:name',
          title: 'Telco',
          titleClass: 'text-primary',
          minWidth: 229
        },
        {
          name: 'telcoSiteId',
          title: 'Telco ID',
          titleClass: 'hidden-md-and-down text-primary',
          dataClass: 'hidden-md-and-down text-primary',
          minWidth: 104
        },
        {
          name: '__slot:totals',
          title: 'Total',
          titleClass: 'text-right text-primary text-bold',
          dataClass: 'text-right text-primary text-bold',
          minWidth: 112
        },
        {
          name: 'expiry',
          title: 'Expiry',
          titleClass: 'text-right text-danger hidden-sm-and-down',
          dataClass: 'text-right text-danger hidden-sm-and-down',
          callback: this.formatDate,
          minWidth: 80
        },
        {
          name: 'CAPEX',
          title: 'CAPEX',
          titleClass: 'text-right hidden-sm-and-down',
          dataClass: 'text-right hidden-sm-and-down',
          callback: this.formatInteger,
          minWidth: 46
        },
        {
          name: 'OPEX',
          title: 'OPEX',
          titleClass: 'text-right hidden-sm-and-down',
          dataClass: 'text-right hidden-sm-and-down',
          callback: this.formatInteger,
          minWidth: 49
        }
      ]
    }
  },

  created () {

    this.st = this.stats ? this.stats : this.getStats()

  },

  mounted () {
//    this.findFinanceSummary(this.setStatement)
  }

}

</script>

<!-- Dev-parity: zero horizontal cell padding + tight line-height to match the
     legacy vuetable-2 render (dev <td> uses `12px 0`). -->
<style scoped>
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { padding-left: 0; padding-right: 0; }
::v-deep .el-table th .cell { white-space: normal; }
::v-deep .el-table th .cell,
::v-deep .el-table td .cell { line-height: 1.25; }
</style>
